(function () {
  function isLeftSwipe(startX, startY, endX, endY, threshold) {
    const horizontalDistance = endX - startX;
    const verticalDistance = Math.abs(endY - startY);
    return horizontalDistance <= -(threshold || 48) && Math.abs(horizontalDistance) > verticalDistance;
  }

  function bind(element, close) {
    if (!element || typeof close !== 'function') return null;

    let startX = 0;
    let startY = 0;

    const onTouchStart = event => {
      const touch = event.changedTouches[0];
      startX = touch.clientX;
      startY = touch.clientY;
    };

    const onTouchEnd = event => {
      if (window.PXUTheme && window.PXUTheme.media_queries && !window.PXUTheme.media_queries.medium.matches) return;
      const touch = event.changedTouches[0];
      if (isLeftSwipe(startX, startY, touch.clientX, touch.clientY)) {
        event.preventDefault();
        close();
      }
    };

    element.addEventListener('touchstart', onTouchStart, { passive: true });
    element.addEventListener('touchend', onTouchEnd, { passive: false });

    return () => {
      element.removeEventListener('touchstart', onTouchStart);
      element.removeEventListener('touchend', onTouchEnd);
    };
  }

  window.mobileDrawerGestures = { bind, isLeftSwipe };
}());
